import { render, staticRenderFns } from "./ConfigurationDrawerComponent.vue?vue&type=template&id=3d8446c9&scoped=true&lang=pug"
import script from "./ConfigurationDrawerComponent.vue?vue&type=script&lang=ts"
export * from "./ConfigurationDrawerComponent.vue?vue&type=script&lang=ts"
import style0 from "./ConfigurationDrawerComponent.vue?vue&type=style&index=0&id=3d8446c9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8446c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d8446c9')) {
      api.createRecord('3d8446c9', component.options)
    } else {
      api.reload('3d8446c9', component.options)
    }
    module.hot.accept("./ConfigurationDrawerComponent.vue?vue&type=template&id=3d8446c9&scoped=true&lang=pug", function () {
      api.rerender('3d8446c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Navigation/Drawer/ConfigurationDrawerComponent.vue"
export default component.exports